import { readingModes, readingTips } from "@/mocks/comicGuide";

export default function ReadingMode() {
  return (
    <section id="reading" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 lg:grid-cols-2 md:px-6">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-book-open-line"></i> 阅读模式详解
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">三种阅读模式，找到最舒服的追漫姿势</h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            漫画阅读软件应用通常提供多种阅读模式，不同模式适合不同场景。看懂它们的区别，追更体验会明显提升。
          </p>

          <div className="mt-6 space-y-4">
            {readingModes.map((m) => (
              <div key={m.title} className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className={`${m.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="text-base font-bold text-foreground-950">{m.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{m.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <img
            src="https://readdy.ai/api/search-image?query=stylized%20warm%20comic%20illustration%20of%20a%20smartphone%20displaying%20a%20manga%20page%20with%20page%20flip%20gesture%2C%20cream%20and%20amber%20palette%2C%20speech%20bubbles%20and%20speed%20lines%2C%20clean%20editorial%20artwork%2C%20soft%20shadow%2C%20high%20detail&width=900&height=1100&seq=comic-reading-mode&orientation=portrait"
            alt="手机屏幕上的漫画翻页阅读模式插画"
            className="h-72 w-full rounded-2xl object-cover object-top lg:h-80"
          />
          <div className="rounded-2xl bg-primary-500 p-6 text-background-50">
            <h3 className="text-lg font-bold">进阶小贴士</h3>
            <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {readingTips.map((tip) => (
                <li key={tip} className="flex items-center gap-2 text-sm">
                  <i className="ri-check-double-line text-secondary-300"></i> {tip}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}